<template>
  <li :class="[baseCss, expandedInternal ? 'bcq-collapsible-item-expanded' : null, disabled ? ['disabled', 'pointer-events-none'] : null]" role="treeitem">
    <table-layout
      @click.native="toggle"
      equal-cells
      y-align="middle"
      :class="[
        expandedInternal ? [
          setTextColor('colorExpanded', 'colorLightnessExpanded'),
          setBgColor('bgColorExpanded', 'bgColorLightnessExpanded')] : [setBgColor(), setTextColor()],
          'bcq-collapsible-item-header',
          'cursor-pointer',
          'outline-none',
          'transition-all',
          'duration-300'
          ]">
      <row>
        <cell v-if="icon" x-align="center" :class="['bcq-collapsible-item-icon', 'px-2', 'py-2.5']">
          <icon :provider="$parent.iconProvider" :name="icon" :color="internalTextColor" :color-lightness="colorLightness" />
        </cell>
        <cell :class="[icon ? 'px-1' : 'px-2', 'py-2.5']">
          <div v-html="label" :class="[$parent.truncateLabels ? 'truncate' : null, 'text-sm', 'font-semibold']" />
        </cell>
        <cell v-if="expandCollapseIcon" x-align="center" :class="['bcq-collapsible-item-icon', 'px-0', 'py-2.5']">
          <icon :provider="$parent.iconProvider" :name="expandedInternal ? $parent.iconCollapse : $parent.iconExpand" :color="internalTextColor" :color-lightness="colorLightness" />
        </cell>
      </row>
    </table-layout>
    <container :style="{maxHeight}" :class="[expandedInternal ? null : ['clip-0', 'absolute', 'opacity-0'], 'transition-all', 'duration-500', 'bcq-collapsible-item-container', 'overflow-auto', 'text-sm', paddingOff ? null : 'p-2']">
      <slot />
    </container>
    <divider v-if="divider" />
  </li>
</template>
<script>
import methods from '../../mixins/methods'
import computed from '../../mixins/computed'

export default {
  name: 'CollapsibleItem',
  mixins: [
    methods,
    computed
  ],
  data () {
    return {
      index: 0,
      baseCss: this.componentBaseCss('collapsible-item', []),
      expandedInternal: this.expanded,
      multiple: this.parent().multiple,
      paddingOff: this.parent().paddingOff,
      bgColor: this.parent().bgColor,
      bgColorLightness: this.parent().bgColorLightness,
      bgColorExpanded: this.parent().bgColorExpanded,
      bgColorLightnessExpanded: this.parent().bgColorLightnessExpanded,
      color: this.parent().color,
      colorLightness: this.parent().colorLightness,
      maxHeight: this.parent().maxHeight,
      colorExpanded: this.parent().colorExpanded,
      colorLightnessExpanded: this.parent().colorLightnessExpanded,
      expandCollapseIcon: this.parent().expandCollapseIcon,
      divider: this.parent().divider
    }
  },
  props: {
    icon: {
      type: String
    },
    label: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean
    },
    expanded: {
      type: Boolean
    }
  },
  mounted () {
    this.getIndex()
  },
  methods: {
    parent () {
      return this.$parent
    },
    getIndex () {
      this.parent().$children.forEach((child, index) => {
        if (child === this) {
          this.index = index
        }
      })
    },
    toggle () {
      if (!this.multiple) {
        this.parent().$children.forEach(child => {
          if (child === this) {
            this.expandedInternal = !this.expandedInternal
          } else {
            child.expandedInternal = false
          }
        })
      } else {
        this.expandedInternal = !this.expandedInternal
      }
      this.$emit(this.expandedInternal ? 'expand' : 'collapse', {
        index: this.index,
        disabled: this.disabled,
        expanded: this.expanded,
        icon: this.icon
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/collapsible-item/collapsible-item.vue